import { L10n, setCulture } from '@syncfusion/ej2-base';

export const polish = function() { 

	setCulture('pl-PL');

	L10n.load({
    'pl-PL': {
        'grid': {
            'EmptyRecord': 'Nie znalazłem danych',
            'GroupDropArea': 'Zgrupuj w całość',
            'UnGroup': 'Kliknij tutaj aby odłączyć od grupy',
            'EmptyDataSourceError': 'Błąd danych w tabeli',
            'Item': 'Element',
            'Items': 'Elementy',
	    'item': 'element'
        },
        'pager':{
            'currentPageInfo': '{0} z {1} stron',
            'totalItemsInfo': '({0} elementów)',
            'totalItemInfo': '({0} element)',
            'firstPageTooltip': 'pierwsza strona',
            'lastPageTooltip': 'ostatnia strona',
            'nextPageTooltip': 'następna strona',
            'previousPageTooltip': 'poprzednia strona',
            'nextPagerTooltip': 'następna grupa stron',
            'previousPagerTooltip': 'poprzednia grupa stron'
        }
    }
});
}();



// WEBPACK FOOTER //
// ./src/components/polish.js